import React, { Component } from 'react';
import PriceItem from './PriceItem';

class PriceTable extends Component {
  render() {
    const { prices, contact } = this.props;

    return (
      <table className="table table-bordered table-striped table-condensed">
        <tbody>
          {prices.map(qty => <PriceItem key={qty.recId} price={qty} contact={contact} />)}
        </tbody>
      </table>
    );
  }
}

export default PriceTable;



// WEBPACK FOOTER //
// ./src/discounts/PriceTable.js